import { render, staticRenderFns } from "./EditBrothersAndSisters.vue?vue&type=template&id=90d5e9f0&scoped=true&"
import script from "./EditBrothersAndSisters.vue?vue&type=script&lang=js&"
export * from "./EditBrothersAndSisters.vue?vue&type=script&lang=js&"
import style0 from "./EditBrothersAndSisters.vue?vue&type=style&index=0&id=90d5e9f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d5e9f0",
  null
  
)

export default component.exports